import * as React from 'react'
import {
    Typography, Grid, Button, IconButton,
    Chip, Box
} from '@mui/material';
import { RHFTextField } from '../../common/hook-form';
import { useFieldArray } from 'react-hook-form';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const AddEditEmailNotes = ({ control, showEmailNotes, setShowEmailNotes }) => {
    const { fields: noteFields, append: appendNote, remove: removeNote } = useFieldArray({ control, name: 'emailNotes' });

    return (
        <>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                    <Button
                        variant="outlined"
                        color="info"
                        size="small"
                        startIcon={<MailOutlineIcon />}
                        onClick={() => setShowEmailNotes(!showEmailNotes)}
                        sx={{ 
                            textTransform: 'none',
                            borderStyle: 'dashed',
                            '&:hover': {
                                borderStyle: 'solid'
                            }
                        }}
                    >
                        {showEmailNotes ? 'Hide Email Notes' : 'Add Email Notes'}
                    </Button>
                    {showEmailNotes && (
                        <Chip 
                            label={`${noteFields.length} Note${noteFields.length !== 1 ? 's' : ''}`}
                            size="small"
                            variant="outlined"
                            color="primary"
                        />
                    )}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    {showEmailNotes ? 'Click to hide email notes section' : 'Click to add multiple custom notes that will be included in the email sent to Carrier'}
                </Typography>
            </Grid>

            {showEmailNotes && (
                <Grid item xs={12}>
                    <Box sx={{ p: 2, bgcolor: 'primary.50', border: '1px solid', borderColor: 'primary.200', borderRadius: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: 'primary.main', display: 'flex', alignItems: 'center' }}>
                            <MailOutlineIcon fontSize="small" sx={{ mr: 1 }} />
                            Email Notes
                        </Typography>
                        
                        {noteFields.map((noteField, index) => (
                            <Box key={noteField.id} sx={{ mb: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500, minWidth: 'fit-content' }}>
                                        Note {index + 1}:
                                    </Typography>
                                    {noteFields.length > 1 && (
                                        <IconButton 
                                            size="small" 
                                            color="error" 
                                            onClick={() => removeNote(index)}
                                            sx={{ ml: 'auto' }}
                                        >
                                            <DeleteForeverIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                                <RHFTextField
                                    name={`emailNotes.${index}.noteFields`}
                                    placeholder="Enter note content that will be included in the email..."
                                    multiline
                                    rows={2}
                                    size="small"
                                    sx={{ 
                                        '& .MuiOutlinedInput-root': {
                                            bgcolor: 'white'
                                        }
                                    }}
                                />
                            </Box>
                        ))}

                        <Button
                            variant="text"
                            color="primary"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => appendNote({ noteFields: '' })}
                            sx={{ 
                                textTransform: 'none',
                                mt: 1
                            }}
                        >
                            Add Another Note
                        </Button>
                    </Box>
                </Grid>
            )}
        </>
    )
}


export default AddEditEmailNotes;